import React from "react";
import Pagination from "./Pagination/Pagination";
import moment from "moment";
function AuditLogsTable(props) {
  return (
    <div style={{ width: "100%" }}>
      <table className="table tableData" style={{ margin: "0px" }}>
        <thead>
          <tr>
            <th>User</th>
            <th>Action</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          {props.logs?.data?.map((item, index) => {
            return (
              <tr key={"list" + index}>
                <td>{item?.name}</td>
                <td>{item?.action}</td>
                <td>{moment(item?.log_date).format("lll")}</td>
              </tr>
            );
          })}
          <Pagination
            totalPost={props.logs?.total}
            postsPerPage={props.logs?.limit}
            setCurrentPage={(e) => props.logsPage(e)}
            currentPage={props.logs?.pageNumber}
          />
        </tbody>
      </table>
    </div>
  );
}

export default AuditLogsTable;
